export const meetings = {
  drawer: {
    title: 'Meetings',
    connectTitle: 'Connect Your Calendar',
    connectDescription:
      'Once connected, Queri will automatically join all your calendar meetings to record, take notes and generate summaries.',
    connecting: 'Connecting...',
    or: 'or',
    upcoming: 'Upcoming Meetings',
    past: 'Past Meetings',
    noUpcoming: 'No upcoming meetings',
    noPast: 'No past meetings',
    settings: 'Meeting Settings',
    fetchStatusFailed: 'Failed to fetch calendar status',
    oauthFailed: 'Failed to initiate OAuth',
    popupBlocked: 'Failed to open OAuth popup. Please allow popups for this site.',
    connected: (provider: string) => `Successfully connected ${provider}!`,
    timedOut: 'OAuth connection timed out. Please try again.',
  },
  settings: {
    title: 'Meeting Settings',
    assistant: 'Meeting Assistant',
    assistantDescription: 'Automatically join and record your meetings',
    disconnect: 'Disconnect',
    confirmDisconnect: 'Yes, disconnect',
    disconnecting: 'Disconnecting...',
    noCalendar: 'No calendar found to disconnect',
    disconnectFailed: 'Failed to disconnect calendar',
    updateAssistantFailed: 'Failed to update meeting assistant',
  },
  botStatus: {
    scheduled: 'Scheduled',
    recording: 'Recording',
    joining: 'Joining',
    recorded: 'Recorded',
    ready: 'Ready',
  },
  detail: {
    notFound: 'Meeting not found',
    loadFailed: 'Failed to load meeting details',
    error: 'Error',
    goBack: 'Go Back',
    backToMeetings: 'Back to Meetings',
    recording: 'Recording',
    videoUnsupported: 'Your browser does not support the video tag.',
    recordingUnavailable: 'Recording not available',
    recordingUnavailableHint: 'The recording may have been deleted or is still processing.',
    processing: 'Processing',
    processingDescription:
      'The meeting summary is being generated. Please check back in a few minutes.',
    summaryFailed: 'Summary Generation Failed',
    summaryFailedDescription: 'An error occurred while generating the summary.',
    summary: 'Summary',
    keyTopics: 'Key Topics',
    actionItems: 'Action Items',
    general: 'General',
    contractDetected: 'Contract Detected',
    confidence: (percent: number) => `${percent}% confidence`,
    parties: 'Parties',
    keyTerms: 'Key Terms',
    notSpecified: 'Not specified',
    contractGenerated: 'Contract Generated',
    contractId: (id: string) => `Contract ID: ${id}`,
    findInDrafts: 'You can find it in your drafts.',
    generationFailed: 'Generation Failed',
    generateContractFailed: 'Failed to generate contract',
    generatingContract: 'Generating Contract...',
    generateContract: 'Generate Contract Draft',
    emailActions: 'Email Actions',
    emailRecipient: 'Email will be sent to:',
    includeContract: 'Include contract attachment',
    emailSent: 'Email Sent',
    emailSentDescription: (email: string) =>
      `The meeting summary has been sent to ${email}`,
    emailFailed: 'Email Failed',
    sendEmailFailed: 'Failed to send email',
    sendingEmail: 'Sending Email...',
    sendEmail: 'Send Summary Email',
    noSummary: 'No Summary Available',
    noSummaryDescription: 'A summary has not been generated for this meeting yet.',
  },
  contractDocument: {
    defaultType: 'Contract Document',
    generated: (docType: string) =>
      `A ${docType.toLowerCase()} has been generated from this meeting. You can preview it or download a copy.`,
    preview: 'Preview',
    download: 'Download',
    downloading: 'Downloading...',
    previewTitle: (docType: string) => `${docType} Preview`,
    previewDescription: (docType: string) =>
      `View-only preview of the generated ${docType.toLowerCase()}.`,
    loadingPreview: 'Loading preview...',
    previewFailed: 'Failed to load preview',
    close: 'Close',
  },
};

export type MeetingsDict = typeof meetings;
